import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { SignOutButton } from '../components/SignOutButton';
import { COPY } from '../copy';
import { useSession } from '../session/useSession';
import { AccountMenu } from './AccountMenu';
import { BrandMark } from './BrandMark';
import { NavTabs } from './NavTabs';
import { useIsDesktop } from './useIsDesktop';

export function TopBar() {
  const isDesktop = useIsDesktop();
  const { me, tenantName, deployEnv } = useSession();

  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      sx={{ borderBottom: 1, borderColor: 'brandChrome.appBarAccent' }}
    >
      <Toolbar variant="dense" sx={{ gap: 2 }}>
        <BrandMark />
        <Typography variant="body2" component="p" color="inherit">
          {tenantName}
        </Typography>
        {deployEnv === 'staging' && (
          <Chip
            label={COPY.stagingLabel}
            size="small"
            variant="outlined"
            sx={{ color: 'inherit', borderColor: 'currentColor' }}
          />
        )}
        {isDesktop && <NavTabs />}
        <Box sx={{ flexGrow: 1 }} />
        {isDesktop ? (
          <>
            <Typography variant="body2" component="p">
              {me.displayName}
            </Typography>
            <SignOutButton color="inherit" />
          </>
        ) : (
          <AccountMenu />
        )}
      </Toolbar>
    </AppBar>
  );
}
